import { render, staticRenderFns } from "./PhaseView.vue?vue&type=template&id=46f9d39b&scoped=true&"
import script from "./PhaseView.vue?vue&type=script&lang=ts&"
export * from "./PhaseView.vue?vue&type=script&lang=ts&"
import style0 from "./PhaseView.vue?vue&type=style&index=0&id=46f9d39b&lang=scss&scoped=true&"
import style1 from "./PhaseView.vue?vue&type=style&index=1&class=scss&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f9d39b",
  null
  
)

export default component.exports